import { z } from 'zod'

export const PersonPriceMetricEnum = {
  LOW: 'LOW',
  MEDIAN: 'MEDIAN',
  HIGH: 'HIGH',
} as const
export const PersonPriceMetricSchema = z.nativeEnum(PersonPriceMetricEnum)
export type PersonPriceMetric = z.infer<typeof PersonPriceMetricSchema>
